import React, { Component } from 'react'
import { mobileos } from '../../utils/Browser'

class BioCard extends React.Component {
    componentDidMount() {
        if (this.refs.image) {
            if (this.refs.image.complete) {
                this.refs.image.classList.add('show')
            }
        }
    }

    imageLoaded() {
        if (this.refs.image) {
            this.refs.image.classList.add('show')
        }
    }

    render() {
        const { props } = this
        return (
            <div className="bio-card">
                <div style={{ position: 'relative' }}>
                    { props.data.image && <img ref="image" onLoad={ () => this.imageLoaded() } src={ props.data.image.resize.src } alt={ props.data.name} /> }
                    <div className={ mobileos ? 'view-bio mobile' : 'view-bio'}>
                    <span className="hoverlink">View Bio</span></div>
                    <div className="mask" />
                </div>
                <p className="name">{ props.data.name }</p>
                { props.data.title && <em>{ props.data.title }</em> }
            </div>
        )
    }

}

export default BioCard



// WEBPACK FOOTER //
// ./src/components/BioCard/index.js